import { defineStore } from 'pinia';

import {
  TerminalDetailResponse,
  TerminalRepository,
} from '@/repositories/generated';
import { TerminalEditForm } from '@/validations';

type TEditTerminalState = {
  form: TerminalEditForm | undefined;
  initData: TerminalDetailResponse | undefined;
};

export const useEditTerminalStore = defineStore('editTerminal', {
  state: (): TEditTerminalState => ({
    form: undefined,
    initData: undefined,
  }),
  actions: {
    async editTerminal() {
      const {
        form,
        initData,
      } = this;

      if (!(form && initData)) return;

      await TerminalRepository.edit({
        id: initData.id,
        requestBody: {
          ...form,
          shopId: form.shopId ?? '',
          externalId: form.externalId ?? '',
          startsAt: form.startsAt.toISOString(),
          endsAt: form.endsAt?.toISOString(),
          terminalStickerId: form.terminalStickerId || undefined,
          lastUpdatedAt: form.lastUpdatedAt,
          terminalPassword: form.canEditTerminalPassword
            ? (form.terminalPassword ?? initData.terminalDetailBasicInfo.terminalPassword)
            : '',
          remarks: form.remarks || null,
          terminalName: form.terminalName || null,
          terminalCustomField1: form.terminalCustomField1 || null,
          terminalCustomField2: form.terminalCustomField2 || null,
          terminalCustomField3: form.terminalCustomField3 || null,
          terminalCustomField4: form.terminalCustomField4 || null,
          terminalCustomField5: form.terminalCustomField5 || null,
        },
      });
    },
    async setInitData(id: string) {
      this.$reset();

      const response = await TerminalRepository.detail({ id });
      this.initData = response;
    },
    setUiForm(form: TerminalEditForm) {
      const createForm = (_form: TerminalEditForm) => ({
        ..._form,
      });
      this.form = createForm(form);
    },
    $resetForm() {
      this.form = undefined;
    },
  },
});
